import { Chip, colors, Container, Grid, Paper } from "@material-ui/core";
import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import { CardActionArea, Button } from "@material-ui/core";
import theminable from "../../../../assets/img/thimanabl.png";
import { useState } from "react";
import { BeatLoader } from "react-spinners";

function ItemCard(props) {
  const { item, onClick, count,group } = props;
  const [loading, setLoading] = useState(false);
  return (
    <div
      sx={{ maxWidth: 345 , minHeight:600,
      }}
      style={{
        padding: `${count == 0 ? "1px" : "0px "}`,
        backgroundColor: "#fff",
        color: "#000",
        direction: "rtl",
        border: `solid ${count == 0 ? "1px #ccc" : "2px " +group?.color==-1? colors.green[300]:
            '#'+group?.color.toString(16).padStart(6,'0')}`,
      }}
    >
      <CardActionArea
        onClick={(e) => {
          onClick(item);
        }}
      >
        <Grid
          container
          style={{
            position: "absolute",

          }}
          justify="space-between"
        >
          <Grid item>
            {" "}
            <Typography
              style={{
                color: "#fff",
                borderRadius: 10,
                paddingInline: 2,
                backgroundColor:group?.color==-1? colors.blue[700]:
                '#'+group?.color.toString(16).padStart(6,'0'),

              }}
              //   variant="outlined"
              size="small"
            >
              {item.sale_price}
            </Typography>
          </Grid>
          <Grid item>
            {" "}
            {count > 0 && (
              <Typography
                style={{
                  color: "#fff",
                  borderRadius: 0,
                  paddingInline: 10,
                  fontSize: 22,
                  backgroundColor: colors.green[400],
                }}
              >
                {count}
              </Typography>
            )}
          </Grid>
        </Grid>
        <Grid xs={12} container justifyContent="center">
          <BeatLoader loading={loading} color={colors.green[300]} />
        </Grid>
        {item.img != null ? (
          <CardMedia
            component="img"
            height="80"
            style={{ padding: 1 }}
            src={`data:image/jpeg;base64,${item.img}`}
            alt="green iguana"
          />
        ) : (
          <CardMedia
            component="img"
            height="80"
            style={{ padding: 2 }}
            image={theminable}
            alt="green iguana"
          />
        )}

        <CardContent
          style={{
            paddingTop: "1px",
            marging: 0,
            padding: 2,
            minHeight: 55,
            maxHeight: 55,
          }}
        >
          <Typography style={{ padding: 1, fontSize: 16, fontWeight: "900" }}>
            {item.symbol}
          </Typography>
          {item.nameEN != "" && (
            <Typography variant="subtitle2" component="div">
              {item.nameEN}
            </Typography>
          )}
        </CardContent>

      </CardActionArea>
    </div>
  );
}

export default ItemCard;
